import 'moment/locale/id';

export default {
    id: {
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: '1 menit',
            mm: '%d menit',
            h: '1 jam',
            hh: '%d jam',
            d: '1 hari',
            dd: '%d hari',
            M: '1 bulan',
            MM: '%d bulan',
            y: '1 tahun',
            yy: '%d tahun',
        }
    }
}
